import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Linkedin } from 'lucide-react';

const teamMembers = [
  {
    name: 'Arjun Bhatt',
    role: 'Founder & Chief Growth Advisor',
    image: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/qsx5mrp8_Arjun%20Bhatt%20pic.jpg',
    linkedin: 'https://www.linkedin.com/in/arjun-bhatt-b53684a/'
  },
  {
    name: 'Bimal Desai',
    role: 'Head of Design',
    image: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/z3abt2n0_bimal-desai%20pic.jpeg',
    linkedin: 'https://www.linkedin.com/in/bimal-desai-b7b53a6/'
  },
  {
    name: 'Kirit Jasani',
    role: 'Partner & Head of Digital Marketing',
    image: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/ftp1fehw_Kirit%20pic.jpeg',
    linkedin: 'https://www.linkedin.com/in/kiritjasani/'
  },
  {
    name: 'Chaitali Patel',
    role: 'Web Development',
    image: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/crw3dob5_chaitali%20pic.jpg',
    linkedin: 'https://www.linkedin.com/in/chaitali-patel-67a80076/'
  }
];

const TeamSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Meet The <span className="text-blue-600">Team</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <Card
              key={index}
              className="border-blue-100 hover:border-blue-300 hover:shadow-xl transition-all duration-300 group bg-white overflow-hidden"
            >
              <div className="relative">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="absolute bottom-4 right-4">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-colors duration-200"
                  >
                    <Linkedin size={20} />
                  </a>
                </div>
              </div>
              <CardContent className="p-6 text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-gray-600">
                  {member.role}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;